import { InputWithTypeahead } from "@dealer-center/ddc-pages-account-search-react";

export const CompareComponent = ({
  selectedValue,
  onChange,
  placeholder
}: {
  selectedValue: string;
  onChange: (value: string) => void;
  placeholder: string;
}) => (
  <InputWithTypeahead
    filterBy="id"
    initialValue={selectedValue}
    placeholder={placeholder}
    size="medium"
    onItemSelected={onChange}
    onSubmit={onChange}
  />
);
